module.exports = __webpack_public_path__ + "img/DAVID_CANNON_07-rs.cd52f638.jpg";